<template>
  <div
    ref="header"
    class="aside__header"
  >
    <div class="aside__header-main">
      <p class="aside__title">
        {{ title }}
      </p>
    </div>
    <Icon
      class="aside__close -header-"
      icon="aside-close"
      @click="closeAside"
    />
    <div class="aside__header-controls">
      <Button
        v-if="saveText"
        :disabled="!canSave"
        :loading="isLoading"
        size="s"
        @click="save"
      >
        {{ saveText }}
      </Button>
      <AsideOptions
        v-if="optionsVisible"
        :is-open="isOpen"
        :option-delete-text="optionDeleteText"
        :option-delete-confirm-text="optionDeleteConfirmText"
        @optionDelete="optionDelete"
        @deleteConfirm="deleteConfirm"
        @closeAside="closeAside"
      >
        <template #items>
          <slot name="optionsItems" />
        </template>
      </AsideOptions>
    </div>

    <transition name="fade">
      <SlotTooltip
        v-if="popupActive"
        :is-open.sync="popupActive"
        position="absolute"
        style="top: 0; right: 0"
      >
        <div
          class="tooltip__block tooltip__delete"
          style="display: block"
        >
          <p class="tooltip__title">
            {{ optionDeleteConfirmText }}
          </p>
          <div class="form__buttons">
            <button
              class="button button--s button-primary"
              type="button"
              @click="optionDelete"
            >
              Да
            </button>
            <button
              class="button button--s button-cancel"
              type="button"
              @click="popupActive = false"
            >
              Нет
            </button>
          </div>
        </div>
      </SlotTooltip>
    </transition>
  </div>
</template>

<script>
import AsideOptions from './AsideOptions';
import Button from '@/components/UiKit/v2/Button';

export default {
  components: { AsideOptions, Button },
  props: {
    title: {
      type: String,
      default: ''
    },
    saveText: {
      type: String,
      default: 'Сохранить'
    },
    canSave: {
      type: Boolean,
      default: true
    },
    optionsVisible: {
      type: Boolean,
      default: false
    },
    isOpen: {
      type: Boolean,
      default: false
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    optionDeleteText: {
      type: String,
      default: ''
    },
    storePath: {
      type: String,
      default: ''
    },
    optionDeleteConfirmText: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    popupActive: false
  }),
  methods: {
    save() {
      if (!this.canSave) {
        return;
      }

      this.$emit('save');
    },
    optionDelete() {
      this.popupActive = false;
      this.$emit('optionDelete');
      this.closeAside();
    },
    closeAside() {
      this.$store.dispatch(`${this.storePath}/setAsideMeta`, {
        path: 'forceClose',
        value: true
      });
    },
    deleteConfirm() {
      this.popupActive = true;
    }
  }
};
</script>
